
type Props = {};

const ShimmerLoader = (props: Props) => {
  return <div>Loading...</div>;
};

export default ShimmerLoader;
